/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface OverlayButtonArgs {
  actionId: string;
  typeName: string;
  disabled: boolean;
  hasContent: boolean;
  isInline?: boolean;
  hasReadOnlyPermission: boolean;
}

export default class OverlayButton extends Component<OverlayButtonArgs> {
  get linkText() {
    let verb = 'Edit';

    if (!this.args.hasContent) {
      verb = 'Add';
    } else if (this.args.hasReadOnlyPermission) {
      verb = 'View';
    }

    return `${verb} ${this.args.typeName}`;
  }
}
